export default __webpack_public_path__ + "static/media/scheduledDowntime.bb771068.png";